import { Injectable } from "@angular/core";
import { ɵNzSliderService as NzSliderService } from "ng-zorro-antd/slider";

@Injectable()
export class UiSliderService extends NzSliderService {}
